import { Component, Input, OnInit } from '@angular/core';
import { isSameModel } from '@app/functions';
import { AuthService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { Applicant } from '@models/recruiting/applicant.model';
import { JobPosting } from '@models/recruiting/job-posting.model';

@Component({
    selector: 'app-applicant-update-basic-information',
    templateUrl: './applicant-update-basic.form.html',
})
export class ApplicantUpdateBasicForm extends BaseForm implements OnInit {
    @Input() applicant: Applicant;
    jobPostings: JobPosting[];
    isSameModel = isSameModel;

    constructor(
        private auth: AuthService,
        private notify: NotifyService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        try {
            const [jobPostings] = await JobPosting.param('company', this.auth.company.id)
                .where('archived_at', null)
                .orderBy('createdAt', 'desc')
                .all();

            this.jobPostings = jobPostings;
        } catch (err) {
            this.notify.error(err.message || 'Could not load job postings');
        }
    }

    onChangeJobPosting(jobPostingId: number): void {
        this.applicant.jobPosting = this.jobPostings.find((jobPosting) => jobPosting.id === jobPostingId);
    }
}
